import React, { useEffect, useState, useMemo } from "react"; // Added useMemo
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import useAuthStore from "store/authStore";
import axios from "axios";
import { IoCopyOutline } from "react-icons/io5";
import { Box, CircularProgress, Typography } from "@mui/material";
import { BASE_URL } from "service";
import AlignListItemCalls from "./AlignListItemCalls"; // Adjust the path as needed
import Lottie from "lottie-react"; // Import Lottie
import runningPersonAnimation from "../Tasks/Tables/running-person.json"; // Replace with your animation file

function MyTeam() {
  const [seen, setSeen] = useState(0);
  const [promotionCode, setPromotionCode] = useState("");
  const [loading, setLoading] = useState(true);
  const [selfEarning, setSelfEarning] = useState("0");
  const [dailyDirectEarning, setDailyDirectEarning] = useState("0");
  const [dailyTotalEarning, setDailyTotalEarning] = useState("0");
  const [referralData, setReferralData] = useState(null);
  const { email } = useAuthStore();
  const [userId, setUserId] = useState(null); // New state for user ID

  // Fetch user profile to get user ID
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/users/profile?email=${encodeURIComponent(email)}`
        );
        if (response.data.message === "User details fetched successfully") {
          setUserId(response.data.user.id); // Set the user ID from profile response
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    if (email) {
      fetchUserProfile();
    }
  }, [email]);

  // Fetch referral data from API using userId
  useEffect(() => {
    const fetchReferralData = async () => {
      if (!userId) return; // Wait until userId is fetched
      try {
        const response = await axios.get(
          `${BASE_URL}/api/referral/referredlevel?user_id=${userId}`
        );
        if (response.data.success) {
          setReferralData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching referral data:", error);
      }
    };

    fetchReferralData();
  }, [userId]); // Run when userId changes

  // Fetch visited links count
  useEffect(() => {
    const visitedLinks = localStorage.getItem("visitedLinks");
    if (visitedLinks) {
      const parsedLinks = JSON.parse(visitedLinks);
      const visitedCount = Object.keys(parsedLinks.links || {}).length;
      setSeen(visitedCount);
    }
  }, []);

  // Fetch promotion code
  useEffect(() => {
    setTimeout(() => {
      const code = localStorage.getItem("referral_code");
      setPromotionCode(code || "No Code Found");
      setLoading(false);
    }, 500);
  }, []);

  // Fetch earning details
  useEffect(() => {
    const fetchEarnings = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/earning/dailyselfearning/?email=${encodeURIComponent(email)}`
        );
        const earnings = response.data.earnings;
        console.log("----earnings    ", earnings);
        setSelfEarning(earnings.daily_self_earning); //ye UI me dashboard me show hoga
        setDailyDirectEarning(earnings.daily_direct_earning || "0");
        setDailyTotalEarning(earnings.daily_total_earning || "0");
      } catch (error) {
        console.error("Error fetching earnings:", error);
      }
    };

    if (email) {
      fetchEarnings();
    }
  }, [email]);

  const totalLinks = 20;

  //  // Update self earning when all tasks are completed
  // useEffect(() => {
  //   const stored = localStorage.getItem("visitedLinks");
  //   if (stored) {
  //     const { date } = JSON.parse(stored);
  //     const todayDate = new Date().toDateString();
  //     // if (seen === totalLinks && selfEarning === "0") {
  //     console.log(
  //       "seen ",
  //       seen,
  //       " selfEarning-",
  //       selfEarning,
  //       " date- ",
  //       date,
  //       " todayDate- ",
  //       todayDate
  //     );
  //     if (seen === 20 && selfEarning === "0" && date === todayDate) {
  //       // setSelfEarning("100");
  //       axios
  //         .post(`${BASE_URL}/api/earning/dailyselfearning/?email=${email}`, {
  //           // dailySelfEarning: "100", //TODO ye toh mater nhi karta h,send karni ki jarurat nhi h
  //         })
  //         .then((response) => {
  //           console.log("Earning API response:", response.data);
  //         })
  //         .catch((error) => {
  //           console.error("Error posting self earning:", error);
  //         });
  //     }
  //   }
  // }, [seen, email, selfEarning]);

  // Function to calculate level counts (for display purposes)
  const getLevelCounts = (data) => {
    const levels = {
      1: { length: 0 },
      2: { length: 0 },
      3: { length: 0 },
      4: { length: 0 },
      5: { length: 0 },
      6: { length: 0 },
      7: { length: 0 },
    };

    function processReferrals(referrals, currentLevel) {
      if (!referrals || !Array.isArray(referrals)) return;

      referrals.forEach((referral) => {
        if (levels[currentLevel]) {
          levels[currentLevel].length += 1;
        }
        processReferrals(referral.referrals, currentLevel + 1);
      });
    }

    if (data?.referrals) {
      processReferrals(data.referrals, 1);
    }
    return levels;
  };

  // Memoize levelCounts to prevent recalculation unless referralData changes
  const levelCounts = useMemo(() => {
    return referralData ? getLevelCounts(referralData) : {};
  }, [referralData]);
  console.log("selfEarmign----", selfEarning);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              {loading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 100,
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <ComplexStatisticsCard
                  color="error"
                  icon="weekend"
                  iconType="IoShareSocial"
                  title="Promotion Code"
                  count={promotionCode}
                  percentage={{
                    color: "success",
                    amount: (
                      <div
                        onClick={() => {
                          navigator.clipboard.writeText(
                            `kamaiclub.com/register?r_code=${promotionCode}`
                          );
                          alert("Copied to clipboard!");
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          marginRight: 10,
                        }}
                      >
                        <IoCopyOutline size={22} />
                      </div>
                    ),
                    label: `kamaiclub.com/register?r_code=${promotionCode}`,
                  }}
                />
              )}
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="weekend"
                iconType="FaTasks"
                title="Direct Member"
                count={levelCounts[1]?.length || 0} // Level 1 count
                percentage={{
                  color: "success",
                  amount: `${totalLinks}`,
                  label: seen === totalLinks ? "Seen All Tasks" : "Tasks Unseen for Today",
                }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="leaderboard"
                iconType="GiReceiveMoney"
                title="Total Team"
                count={Object.values(levelCounts).reduce((sum, level) => sum + level.length, 0)} // Total team count
                percentage={{
                  color: "success",
                  label: "For completed all tasks",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>

        {/* Pass referral data to AlignListItemCalls with Lottie animation as loader */}
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MDBox mb={3}>
                {referralData ? (
                  <AlignListItemCalls referralData={referralData} />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: 200, // Adjust height as needed
                    }}
                  >
                    <Lottie
                      animationData={runningPersonAnimation}
                      loop={true}
                      style={{ width: 200, height: 200 }}
                    />
                  </Box>
                )}
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MyTeam;
